export default __webpack_public_path__ + "static/media/DeniedCollaboratorStatusIcon.32bb3746.svg";